import Vue from 'vue';
import App from './App';
import { router } from './router';
import store from './store'
// 路由权限拦截
// import './utils/permission'
/* import  VConsole  from  'vconsole'
const  vConsole = new VConsole() //注意 
Vue.use(vConsole) */
import { Button, Row, Col, Toast } from 'vant'
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.use(Button)
  .use(Row)
  .use(Col)
  .use(Toast)
// vant 常用组件全局注册
/* import { Button, Row, Col, Toast } from 'vant'
Vue.use(Button)
  .use(Row)
  .use(Col)
  .use(Toast) */

// 移动端rem适配js
// import '@/assets/js/rem.js'

// 打印当前运行模式
console.log('当前运行模式为:', process.env)

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});
